import { useMemo } from "@discovery/common-dplus/lib/hooks";
import * as styles from "./styles.css";
const PlayerView = React.lazy(() => import("../../../component-creators/player"));
const VideoPagePlayer = ({ read, streamIDM, imaAdsConfig, getVideoDetails, broadcastType, packagesM, }) => {
    const handleVideoChange = (path, seasonNumber, id) => {
        const newUrl = `/videos/${path}` + `?seasonId=${seasonNumber}`;
        window.history.pushState({ path: newUrl }, "", newUrl);
        getVideoDetails && getVideoDetails(id);
    };
    return useMemo(() => (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.videoPlayerPlaying, id: "isPlayingVideo" },
            React.createElement(React.Suspense, { fallback: () => React.createElement(React.Fragment, null) },
                React.createElement(PlayerView, { read: read, streamIDM: streamIDM, imaAdsConfig: imaAdsConfig, broadcastType: broadcastType, onPlayNextE: (path, seasonNumber, id) => {
                        handleVideoChange(path, seasonNumber, id);
                    }, packagesM: packagesM }))))), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
};
export default VideoPagePlayer;

